import {Directory} from '@/components/main/directory/Directory';

export default function DirectoryIndex() {
  try {
    return <Directory />;
  } catch (error) {
    // TODO: 추후 에러페이지로 리턴할지, 메인으로 리다리엑트시킬지..기획적으로 정해봐야할듯!
  }
}
